import { base } from './base'

export const modalStyles = {
  ...base,
  position: 'fixed',
  zIndex: '999999999999',
  left: '0',
  top: '0',
  width: '100%',
  height: '100%',
  margin: 'auto',
  overflow: 'auto',
  backgroundColor: 'rgb(49, 71, 128, 0.8)',
}
